// Ant Design Theme Configuration for Dark/Light Modes
import { theme } from 'antd';

const { defaultAlgorithm, darkAlgorithm } = theme;

// Light Theme Configuration
export const lightTheme = {
  algorithm: defaultAlgorithm,
  token: {
    // Primary Colors
    colorPrimary: '#1890ff',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: '#1890ff',
    
    // Background Colors
    colorBgContainer: '#ffffff',
    colorBgElevated: '#ffffff',
    colorBgLayout: '#f5f5f5',
    colorBgSpotlight: '#ffffff',
    colorBgMask: 'rgba(0, 0, 0, 0.45)',
    
    // Text Colors - Optimized for lighter, more pleasant appearance
    colorText: '#4a5568',           // Soft dark gray instead of harsh black
    colorTextSecondary: '#718096',  // Medium gray for secondary text
    colorTextTertiary: '#a0aec0',   // Light gray for tertiary text
    colorTextQuaternary: '#cbd5e0', // Very light gray for quaternary text
    
    // Border Colors - Softer and more pleasant
    colorBorder: '#cbd5e0',     // Softer primary border
    colorBorderSecondary: '#e2e8f0', // Softer secondary border
    
    // Component specific
    borderRadius: 6,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.15)',
    boxShadowSecondary: '0 6px 16px rgba(0, 0, 0, 0.08)',
  },
  components: {
    Layout: {
      headerBg: '#ffffff',
      siderBg: '#001529',
      bodyBg: '#f5f5f5',
    },
    Menu: {
      darkItemBg: '#001529',
      darkSubMenuItemBg: '#000c17',
      darkItemSelectedBg: '#1890ff',
    },
    Button: {
      borderRadius: 6,
    },
    Card: {
      headerBg: '#fafafa',
    },
  },
};

// Dark Theme Configuration
export const darkTheme = {
  algorithm: darkAlgorithm,
  token: {
    // Primary Colors
    colorPrimary: '#1890ff',
    colorSuccess: '#52c41a',
    colorWarning: '#faad14',
    colorError: '#ff4d4f',
    colorInfo: '#1890ff',
    
    // Background Colors
    colorBgContainer: '#1f1f1f',
    colorBgElevated: '#262626',
    colorBgLayout: '#0f172a',
    colorBgSpotlight: '#262626',
    colorBgMask: 'rgba(0, 0, 0, 0.65)',
    
    // Text Colors - Enhanced for better readability
    colorText: '#ffffff',           // Pure white for primary text
    colorTextSecondary: '#e2e8f0',  // Very light gray for secondary text
    colorTextTertiary: '#cbd5e1',   // Light gray for tertiary text
    colorTextQuaternary: '#94a3b8', // Medium gray for quaternary text
    
    // Border Colors
    colorBorder: '#424242',
    colorBorderSecondary: '#303030',
    
    // Component specific
    borderRadius: 6,
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.45)',
    boxShadowSecondary: '0 6px 16px rgba(0, 0, 0, 0.25)',
  },
  components: {
    Layout: {
      headerBg: '#1f1f1f',
      siderBg: '#001529',
      bodyBg: '#0f172a',
    },
    Menu: {
      darkItemBg: '#001529',
      darkSubMenuItemBg: '#000c17',
      darkItemSelectedBg: '#1890ff',
    },
    Button: {
      borderRadius: 6,
    },
    Card: {
      headerBg: '#262626',
    },
    Drawer: {
      colorBgElevated: '#1f1f1f',
    },
    Modal: {
      contentBg: '#1f1f1f',
      headerBg: '#1f1f1f',
    },
  },
};

// Get theme configuration based on current theme
export const getThemeConfig = (isDark) => {
  return isDark ? darkTheme : lightTheme;
};
